__turbopack_context__.v({
  "accordion_container": "styles-module-scss-module__yOPL4G__accordion_container",
  "container": "styles-module-scss-module__yOPL4G__container",
  "content_container": "styles-module-scss-module__yOPL4G__content_container",
  "photos_container": "styles-module-scss-module__yOPL4G__photos_container",
  "red_caret_theme_override": "styles-module-scss-module__yOPL4G__red_caret_theme_override",
  "side_bar": "styles-module-scss-module__yOPL4G__side_bar",
  "summary": "styles-module-scss-module__yOPL4G__summary",
  "tabs": "styles-module-scss-module__yOPL4G__tabs",
});
